import { Action } from '@/_core/fluxstore/types';
import { StorymapState } from '../../types';
import { useStorymapStore } from '../../useModule';

const { registerReducer } = useStorymapStore();

export class ChangeAssigneeFilter extends Action<StorymapState> {
    public static ACTION_TYPE = 'ChangeAssigneeFilter';

    public constructor(public assigneeUserId: string) {
        super(ChangeAssigneeFilter.ACTION_TYPE);
    }
}

const reducer = (state: StorymapState, action: ChangeAssigneeFilter): void => {
    if (state.filterState.assigneeUserIds.includes(action.assigneeUserId)) {
        state.filterState.assigneeUserIds = state.filterState.assigneeUserIds.filter((x) => x !== action.assigneeUserId);
    } else {
        state.filterState.assigneeUserIds.push(action.assigneeUserId);
    }
};

//@ts-ignore
registerReducer(ChangeAssigneeFilter.ACTION_TYPE, reducer);
